import { IonCard, IonCol, IonGrid, IonRow } from '@ionic/react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DAService from '../../services/DAService.service';
import TextHelper from '../../utils/TextHelper';
import ListGrid from '../ListGrid/ListGrid';
import OptionModal from '../Modal/OptionModal';
// import OptionsDummyData from '../../services/OptionsDummyData';
import './Options.scss';

export default function Options() {
  const [option, setOption] = useState<any>();
  const [optionOTD, setOptionOTD] = useState<any[]>([]);
  const [options, setOptions] = useState<any[]>([]);

  useEffect(() => {
    setOptionOTD(DAService.getPlaylist('optionoftheday'));
    setOptions(DAService.getPlaylist('options'));
  }, []);

  return (
    <IonGrid style={{ padding: '16px 0px' }}>
      <OptionModal option={option} setOption={setOption} />
      <IonRow className="date-option">
        {moment().utc().format('ll').toUpperCase()}
      </IonRow>
      <IonRow style={{ paddingBottom: '8px' }}>
        <IonCol
          sizeLg="5.5"
          sizeMd="7"
          sizeXs="12"
          style={{ paddingLeft: '0px', paddingRight: '0px' }}
        >
          <IonRow className="header-option" data-testid="option-of-the-day">
            Option of the Day
          </IonRow>
          <IonRow>
            {optionOTD.map((optionOfTheDay) => {
              const iconExtension = optionOfTheDay.icon.replace('svg', 'png');
              // eslint-disable-next-line
              const iconPath = require(`../../assets/optionsOTD/${iconExtension}`);
              return (
                <IonCard className="card-option-container" key={`optionOftheDay-${optionOfTheDay.itemId}`} onClick={(() => setOption(optionOfTheDay))}>
                  <img alt="" src={iconPath} style={{ background: optionOfTheDay.color }} />
                  <div className="card-content-option">
                    <IonRow className="card-content-title">
                      {TextHelper.stripHTML(optionOfTheDay?.name)}
                    </IonRow>
                    <IonRow className="card-content-description">
                      {`${TextHelper.stripHTML(optionOfTheDay?.description)?.substring(0, 44)}...`}
                    </IonRow>
                  </div>
                </IonCard>
              );
            })}
          </IonRow>
        </IonCol>
        <IonCol sizeLg="1" sizeMd="1" />
        <IonCol
          sizeLg="5.5"
          sizeMd="4"
          sizeXs="12"
          style={{ paddingLeft: '0px', paddingRight: '0px' }}
        >
          <IonRow className="header-option" data-testid="popular-options">
            Popular Options
          </IonRow>
          {options?.map((item, index) => (
            <button
              data-testid="click-button"
              style={{ background: 'transparent', padding: '0px', textAlign: 'inherit', width: '100%' }}
              type="button"
              key={`options${item.itemId}`}
              onClick={(() => setOption(item))}
            >
              <ListGrid
                item={item}
                arrayLength={DAService.getPlaylist('options').length}
                index={index}
                itemType="popular-option"
              />
            </button>
          ))}
        </IonCol>
      </IonRow>
    </IonGrid>
  );
}
